export default __webpack_public_path__ + "static/media/edit-widet.884ce078.png";